export const extractChessresultsTournamentId = (input: string): string | null => {
    if (/^\d+$/.test(input)) {
        return input;
    }

    // Try to match the standard format: tnr{id}.aspx
    const standardMatch = input.match(/tnr(\d+)\.aspx/);
    if (standardMatch) {
        return standardMatch[1];
    }

    // Try to match the tno parameter format: tno={id}
    const tnoMatch = input.match(/[?&]tno=(\d+)/);
    if (tnoMatch) {
        return tnoMatch[1];
    }

    return null;
};
